import {
  CheckUserPermissionsCommand,
  CheckUserPermissionsCommandInput,
  CreateUserV2Command,
  CreateUserV2CommandInput,
  DeleteUserV2Command,
  DeleteUserV2CommandInput,
  GetUserMetadataV2Command,
  GetUserMetadataV2CommandInput,
  GetUserV2Command,
  GetUserV2CommandInput,
  ListUsersV2Command,
  ListUsersV2CommandInput,
  UpdateUserV2Command,
  UpdateUserV2CommandInput,
} from '@amzn/gbsa-orbit-typescript-client';
import { apiOrbitClient } from 'src/data/api/apiOrbitClient';

export const userService = {
  // Get all users
  list: (data: ListUsersV2CommandInput) => {
    return apiOrbitClient.send(new ListUsersV2Command(data));
  },

  getUserById: (data: GetUserV2CommandInput) => {
    return apiOrbitClient.send(new GetUserV2Command(data));
  },

  getUserMetadata: (data: GetUserMetadataV2CommandInput) => {
    return apiOrbitClient.send(new GetUserMetadataV2Command(data));
  },

  // // Create new user
  create: (data: CreateUserV2CommandInput) => {
    return apiOrbitClient.send(new CreateUserV2Command(data));
  },

  // // Update user
  update: (data: UpdateUserV2CommandInput) => {
    return apiOrbitClient.send(new UpdateUserV2Command(data));
  },

  delete: (data: DeleteUserV2CommandInput) => {
    return apiOrbitClient.send(new DeleteUserV2Command(data));
  },
  checkUserPermission: (data: CheckUserPermissionsCommandInput) => {
    return apiOrbitClient.send(new CheckUserPermissionsCommand(data));
  },
};
